import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClaimListSearchCriteria, ClaimViewResponse } from '../model/claim-model';

@Injectable({
  providedIn: 'root'
})
export class ClaimService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.claim;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getClaimList(criteria: ClaimListSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }

  getClaimView(docNo): Observable<ClaimViewResponse> {
    const url = this.getFullUrlWithStoreNo(this.envService.view, docNo);

    return this.http.get<ClaimViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
